import React from 'react';
import { useRouter } from 'next/router';

interface Props {
    title: string;
    description: string;
    featuredImage: any;
    url: string;
}

export const FeaturedPost = ({ title, description, featuredImage, url }: Props) => {
    const router = useRouter();
    return (<div className='blog--featured cursor-pointer select-none' onClick={() => router.push(url)}>
        <div className='blog--featured-wrapper'>
            {featuredImage && <div className='blog--featured-image'>
                <img src={featuredImage.url} />
            </div>}
            <div className='blog--featured-content'>
                <h3 className='blog--featured-title'>{title}</h3>
                <p className='blog--featured-description'>{description}</p>
                <a className='blog--featured-link' href={url}>
                    <span>Read More</span><img src='/assets/icons/arrow-right.svg' />
                </a>
            </div>
        </div>

        <style jsx>
            {`
                .blog--featured {
                    padding: 92px 40px 128px;
                    margin: 0 auto;
                    background-image: url('/assets/backgrounds/blog-featured-bg.svg');
                    background-repeat: no-repeat;
                    background-size: 87%;
                    background-position: right bottom;

                    .blog--featured-wrapper {
                        max-width: 1357px;
                        display: flex;
                        width: 100%;
                        margin: 0 auto;
                        align-items: center;
                        background: #121651;
                        border-radius: 10px;
                        padding: 40px 39px;
                        position: relative;
                        overflow: hidden;

                        .blog--featured-image {
                            flex: 10;

                            img {
                                width: 100%;
                                height: auto;
                                border-radius: 10px;
                            }
                        }

                        .blog--featured-content {
                            padding: 34px 60px 22px 57px;
                            flex: 6;

                            &:before {
                                content: 'NEW';
                                background: linear-gradient(135deg, #E637A8 2.69%, #E68137 75%);
                                border-radius: 0px 10px;
                                font-weight: 900;
                                font-size: 21px;
                                line-height: 21px;
                                text-align: center;
                                color: #FFFFFF;
                                position: absolute;
                                right: 0;
                                top: 0;
                                width: 172px;
                                height: 44px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                            }

                            .blog--featured-title {
                                font-weight: 800;
                                font-size: 36px;
                                line-height: 49px;
                                color: #FFFFFF;
                                margin: 0;
                            }


                            .blog--featured-description {
                                font-weight: 500;
                                font-size: 18px;
                                line-height: 25px;
                                color: #FFFFFF;
                                margin: 17px 0 0;
                            }

                            .blog--featured-link {
                                display: flex;
                                margin-top: 35px;

                                &:hover {
                                    img {
                                        margin-left: 18px;
                                    }
                                }

                                span {
                                    font-weight: 800;
                                    font-size: 24px;
                                    line-height: 28px;
                                    background: -webkit-linear-gradient(135deg,
                                    #e637a8 2.69%,
                                    #e68137 75%);
                                    -webkit-background-clip: text;
                                    -webkit-text-fill-color: transparent;
                                    text-decoration-line: underline;
                                }

                                img {
                                    width: 35px;
                                    height: auto;
                                    margin-left: 6px;
                                    transition: margin-left 150ms ease;
                                }
                            }
                        }
                    }

                    @media (max-width: 992px) {
                        padding: 80px 40px;

                        .blog--featured-wrapper {
                            .blog--featured-content {
                                padding: 35px 35px 35px 65px;
                            }
                        }
                    }

                    @media (max-width: 768px) {
                        background: none;

                        .blog--featured-wrapper {
                            padding: 0;
                            flex-direction: column;

                            .blog--featured-image {
                                img {
                                    border-radius: 0;
                                }
                            }

                            .blog--featured-content {
                                padding: 37px 20px 75px;
                                position: relative;

                                &:before {
                                    top: -22px;
                                    right: 15px;
                                    width: 94px;
                                    height: 34px;
                                    border-radius: 3px;
                                    font-size: 18px;
                                }

                                .blog--featured-title {
                                    font-size: 28px;
                                    line-height: 120%;
                                }

                                .blog--featured-description {
                                    margin-top: 20px;
                                }

                                .blog--featured-link {
                                    margin-top: 30px;

                                    img {
                                        width: 30px;
                                        margin-top: 3px;
                                    }
                                }
                            }
                        }
                    }

                    @media (max-width: 480px) {
                        padding: 60px 25px;
                    }
                }
            `}
        </style>
    </div>);
};
